import React from 'react';

// interface AggregatedSalesDto {
//   level: string;
//   name: string;
//   role: string;
//   personName: string;
//   jobDuration: string;
//   monthlySoQty: { [month: string]: number };
//   monthlyPerSoIms: { [month: string]: number };
// }

// interface Props {
//   data: AggregatedSalesDto[];
// }

const SalesPerformanceTable = ({ data }) => {

  //alert(data.length);

    const getLastThreeMonths = ()=> {
        const months = [];
        const now = new Date();

        for (let i = 2; i >= 0; i--) {
            const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
            const monthName = d.toLocaleString('default', { month: 'long' });
            months.push(monthName);
        }

        return months;
        };

        const months = getLastThreeMonths();
        //const months = ['March', 'April', 'May'];

        const fontSize = "text-[0.2rem]";

         const getRowBgColor = (level) => {
          // alert(level);
          switch (level) {
            case 1:
              return 'bg-level-1'; // Zone
            case 2:
              return 'bg-level-2'; // Division
            case 3:
              return 'bg-level-3'; // Area
            default:
              return 'bg-level-4'; // Territory or others
          }
        };

        // const abc = getRowBgColor(1);
        // alert(abc);

          // function getBgColors(level: number) {
            
          //     if (level == 1) {
          //       return { levelBgColor: "#9bba7b"};
          //     } else if (level == 2) {
          //       return { levelBgColor: "#ebb298"};
          //     } else if (level == 3) {
          //       return { levelBgColor: "#d5edf5"};
          //     } else {
          //       return { levelBgColor: "#b4b4c2"};
          //     }
                 
          //     return { levelBgColor: "b4b4c2"};
          // }

          // const levelBgColor = "#9bba7b";

  return (
 
      <table className="`table divide-y divide-gray-200 ${fontSize}`">
        <thead className="bg-gray-100 text-left">
          <tr>
            {/* <th className="px-4 py-2">Level</th> */}
            <th className="px-4 py-2">DSM/RM/TSM</th>
            <th className="px-4 py-2">Role</th>
            <th className="px-4 py-2">Person</th>
            <th className="px-4 py-2">Job&nbsp;Duration</th>
            <th className="px-4 py-2">So Qty</th>
            <th className="px-4 py-2">Below 20k</th>

            {months.map((month) => (
              <React.Fragment key={month}>
                {/* <th className="px-4 py-2 text-center">{month} Qty</th> */}
                <th className="px-4 py-2 text-center">{month} IMS</th>
              </React.Fragment>
            ))}

            <th className="px-4 py-2 text-center">So Dropout</th>
          </tr>
        </thead>

        <tbody className="divide-y divide-gray-100">
          {data.map((item, index) => (
            <tr key={item.allId} className={`${getRowBgColor(item.level)}`}>
              {/* <td className="px-4 py-2">{item.level}</td> */}
              <td className="px-4 py-2">{item.name}</td>
              <td className="px-4 py-2">{item.role || '-'}</td>
              <td className="px-4 py-2">{item.personName || '-'}</td>
              <td className="px-4 py-2">{item.jobDuration || '-'}</td>
              <td className="px-4 py-2">{item.soQty || '0'}</td>
              <td className="px-4 py-2">{item.below20k || '0'}</td>
              {months.map((month) => (
                <React.Fragment key={month}>
                  {/* <td className="px-4 py-2 text-center">
                    {item.monthlySoQty?.[month] ?? 0}
                  </td> */}
                  <td className="px-4 py-2 text-center">
                    {item.monthlyPerSoIms?.[month]
                      ? item.monthlyPerSoIms[month].toLocaleString()
                      : 0}
                  </td>
                </React.Fragment>
              ))}

              <td className="px-4 py-2">{item.soDropQty || '0'}</td>              
            </tr>
          ))}
        </tbody>
      </table>
    
  );
};

export default SalesPerformanceTable;
